import * as React from "react";
import { ThreadTypeSwitch, ThreadTypeSwitchItem } from "./styledComponents";
import { FormattedMessage } from "react-intl";
import { useEventCallback } from "@vingle/wtf-sdk/helpers/hook";

export interface IThreadFilter {
  filters: Array<{ id: string; intlId?: string }>;
  currentFilter: string;
  onChange: (filter: string) => void;
}

const ThreadFilter = React.memo(
  ({ filters, currentFilter, onChange }: IThreadFilter) => {
    const handleChangeFilter: React.ChangeEventHandler<
      HTMLInputElement
    > = useEventCallback(e => {
      onChange(e.target.value);
    });
    return (
      <ThreadTypeSwitch>
        {filters.map(filter => (
          <ThreadTypeSwitchItem key={`threadFilter__${filter.id}`}>
            <input
              type="radio"
              name="comment-type-switch"
              checked={currentFilter === filter.id}
              onChange={handleChangeFilter}
              value={filter.id}
            />
            {filter.intlId ? (
              <span>
                <FormattedMessage id={filter.intlId} />
              </span>
            ) : (
              filter.id
            )}
          </ThreadTypeSwitchItem>
        ))}
      </ThreadTypeSwitch>
    );
  },
);

export default ThreadFilter;
